export const MethodOfIntroduction = [
  {
    value: "0",
    label: "هیچکدام",
  },
  {
    value: "دیوار",
    label: "دیوار",
  },
  {
    value: "بازاریاب",
    label: "بازاریاب",
  },
  {
    value: "گوکل و اینترنت",
    label: "گوگل و اینترنت",
  },
  {
    value: "سایت",
    label: "سایت",
  },
  {
    value: "دوستان و آشنایان",
    label: "دوستان و آشنایان",
  },
  {
    value: "اینستاگرام",
    label: "اینستاگرام",
  },
  {
    value: "پیک",
    label: "پیک",
  },
  {
    value: "تلگرام",
    label: "تلگرام",
  },
  {
    value: "مشتری قدیمی",
    label: "مشتری قدیمی",
  },
  {
    value: "واتساپ",
    label: "واتساپ",
  },
  {
    value: "همکاران",
    label: "همکاران",
  },
  {
    value: "Bs",
    label: "Bs",
  },
  {
    value: "سایر",
    label: "سایر",
  },
];
export const MethodOfSell = [
  {
    value: "0",
    label: "هیچکدام",
  },
  {
    value: "مغازه",
    label: "مغازه",
  },
  {
    value: "خانگی",
    label: "خانگی",
  },
  {
    value: "اینترنتی",
    label: "اینترنتی",
  },
  {
    value: "اینترنتی خانگی",
    label: "اینترنتی خانگی",
  },
  {
    value: "دست فروشی",
    label: "دست فروشی",
  },
  {
    value: "مغازه اینترنت",
    label: "مغازه اینترنت",
  },
];
export const CustomerRanking = [
  {
    value: "طلایی",
    label: "طلایی",
  },
  {
    value: "نقره ای",
    label: "نقره ای",
  },
  {
    value: "برنزی",
    label: "برنزی",
  },
  {
    value: "معمولی",
    label: "معمولی",
  },
  {
    value: "vip",
    label: "vip",
  },
];
export const CustomerType = [
  {
    value: "سرنخ",
    label: "سرنخ",
  },
  {
    value: "مشتری",
    label: "مشتری",
  },
];
export const ActionType = [
  {
    value: "تماس ورودی",
    label: "تماس ورودی",
  },
  {
    value: "پیگیری",
    label: "پیگیری",
  },
  {
    value: "پیگیری دوره ای سفارش جدید",
    label: "پیگیری دوره ای سفارش جدید",
  },
  {
    value: "پیگیری دریافت بار در مشهد",
    label: "پیگیری دریافت بار در مشهد",
  },
  {
    value: "پیگیری دریافت بار در شهرستان",
    label: "پیگیری دریافت بار در شهرستان",
  },
  {
    value: "تماس خروجی",
    label: "تماس خروجی",
  },
  {
    value: "مراجعه حضوری",
    label: "مراجعه حضوری",
  },
  {
    value: "مراجعه به انبار",
    label: "مراجعه به انبار",
  },
  {
    value: "شارژ محصول",
    label: "شارژ محصول",
  },
  {
    value: "ویزیت حضوری",
    label: "ویزیت حضوری",
  },
  {
    value: "پیگیری دوره ای تماس",
    label: "پیگیری دوره ای تماس",
  },
];
export const ActionStatus = [
  {
    value: "در حال بررسی",
    label: "در حال بررسی",
  },
  {
    value: "انجام شده",
    label: "انجام شده",
  },
  {
    value: "ناموفق",
    label: "ناموفق",
  },
];
export const TagSelection = [
  {
    value: "انتخاب کنید",
    label: "انتخاب کنید",
  },
  {
    value: "شرکت",
    label: "شرکت",
  },
  {
    value: "ویزیتور بدنهcrm",
    label: "ویزیتور بدنهcrm",
  },
  {
    value: "سرنخ crm",
    label: "سرنخ crm",
  },
  {
    value: "مشتری VIP",
    label: "مشتری VIP",
  },
  {
    value: "crm وبازاریاب",
    label: "crm وبازاریاب",
  },
  {
    value: "مشتری(بدنه)",
    label: "مشتری(بدنه)",
  },
  {
    value: "Bs",
    label: "Bs",
  },
];
export const KindCustomer = [
  {
    value: "مشتری",
    label: "مشتری",
  },
  {
    value: "سرنخ",
    label: "سرنخ",
  },
];

export const KindSeller = [
  {
    value: "مغازه",
    label: "مغازه",
  },
  {
    value: "خانگی",
    label: "خانگی",
  },
  {
    value: "اینترنتی",
    label: "اینترنتی",
  },
  {
    value: "اینترنتی خانگی",
    label: "اینترنتی خانگی",
  },
  {
    value: "دست فروشی",
    label: "دست فروشی",
  },
  {
    value: "مغازه اینترنت",
    label: "مغازه اینترنت",
  },
];
export const PurchasePosibility = [
  {
    value: "کم",
    label: "کم",
  },
  {
    value: "متوسط",
    label: "متوسط",
  },
  {
    value: "زیاد",
    label: "زیاد",
  },
  {
    value: "نامشخص",
    label: "نامشخص",
  },
];

export const Categories = [
  {
    value: "شال و روسری",
    label: "51",
  },
  {
    value: "لباس زنانه",
    label: "52",
  },
  {
    value: "لباس بچگانه",
    label: "53",
  },
  {
    value: "لباس زیر",
    label: "54",
  },
  {
    value: "دندان",
    label: "55",
  },
];

export const DeleteReason = [
  {
    value: "مشتری تامین کننده است",
    label: "مشتری تامین کننده است",
  },
  {
    value: "چکی میخواست",
    label: "چکی میخواست",
  },
  {
    value: "فعالیت نداره",
    label: "فعالیت نداره",
  },
  {
    value: "مغازشو جمع کرده",
    label: "مغازشو جمع کرده",
  },
  {
    value: "تغییر شغل داده",
    label: "تغییر شغل داده",
  },
  {
    value: "قیمتامون بالاست",
    label: "قیمتامون بالاست",
  },
  {
    value: "فاکتور زیر کف خرید میخواست",
    label: "فاکتور زیر کف خرید میخواست",
  },
  {
    value: "شمارش اشتباهه",
    label: "شمارش اشتباهه",
  },
  {
    value: "بلاکه",
    label: "بلاکه",
  },
  {
    value: "خاموشه",
    label: "خاموشه",
  },
  {
    value: "فروش همکاری مخیواسته",
    label: "فروش همکاری مخیواسته",
  },
  {
    value: "پاسخگو نیست",
    label: "پاسخگو نیست",
  },
  {
    value: "بدون شمارس",
    label: "بدون شمارس",
  },
  {
    value: "عمده فروشه",
    label: "عمده فروشه",
  },
  {
    value: "تمایل به خرید نداره",
    label: "تمایل به خرید نداره",
  },
  {
    value: "مرجوعی",
    label: "مرجوعی",
  },
];

export const TagsLang = [
  { value: "fa", label: "فارسی" },
  { value: "en", label: "انگلیسی" },
  { value: "ar", label: "عربی" },
];
